import { defineMessages } from 'react-intl';

const apnDeprecationUXMessages = defineMessages({
  alertContent: {
    id: 'apnDeprecationUXMessages.alertContent',
    defaultMessage:
      'On February 3, 2026, the APN sign-in option will be removed. After this date, please use AWS Builder ID with the same email to sign in. All your training history from APN will be available under your AWS Builder ID.',
    decription: 'alert content for APN deprecation',
  },
});

export default apnDeprecationUXMessages;
